import { Country } from '../types/country'
import api from './axios'

const baseUrl = '/rest/v1/countries'

export async function getCountries(): Promise<Country[]> {
    const res = await api.get<PagedResult<Country>>(baseUrl)
    return res.data.items
}